export const systemStatusOptions = [
  { Name: "Alla", Value: "-1" },
  { Name: "Utkast", Value: "0" },
  { Name: "Aktiv", Value: "1" },
  { Name: "Avslutad", Value: "2" },
  { Name: "Borttagen", Value: "3" },
  { Name: "Pausad", Value: "4" },
  { Name: "Matchningsförslag", Value: "5" },
];
